export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10876.88a05701.jpg";